"use client";
import React from "react";

import useBlogCategory from "./useBlogCategory";

const BlogCategory = () => {
  const { blogCategories, selectedCategory, handleSelectCategory } =
    useBlogCategory();

  return (
    <div className="flex items-center space-x-5 mt-12 overflow-x-auto xscroll pb-2">
      {blogCategories &&
        [{ name: "All", _id: null, description: "" }, ...blogCategories]?.map(
          (category) => (
            <button
              key={category?._id}
              className={`${selectedCategory._id === category._id ? "bg-primary dark:bg-primary-50 text-white" : "bg-transparent text-foreground"} cursor-pointer px-3 py-2 text-sm rounded-full hover:bg-primary/50 transition-all duration-300 ease-in-out capitalize`}
              onClick={() => handleSelectCategory(category)}
            >
              {category.name}
            </button>
          ),
        )}
    </div>
  );
};

export default BlogCategory;
